module.exports = __webpack_public_path__ + "img/17_102.c1544dc4.png";